import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaGlobe } from 'react-icons/fa';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  const languages = [
    { code: 'pt', name: 'Português', flag: '🇧🇷' },
    { code: 'en', name: 'English', flag: '🇺🇸' },
  ];

  return (
    <div className="language-switcher">
      <div className="language-current" onClick={() => changeLanguage(i18n.language === 'pt' ? 'en' : 'pt')}>
        <FaGlobe className="language-icon" />
        <span className="current-language">
          {languages.find(lang => lang.code === i18n.language)?.flag}
        </span>
        <span className="language-code">
          {i18n.language === 'pt' ? 'PT' : 'EN'}
        </span>
      </div>
    </div>
  );
};

export default LanguageSwitcher;